import { Button, Divider, Space, Typography } from "antd";
import ResponsiveCol from "../form/ResponsiveCol";
import { useMemo, useState } from "react";
import { UseTableSelectionReturn } from "hooks/commons/useTableSelection";
import AssignCFDI from "./AssignCFDI";
import { COMPLEMENT_PARENT } from "routes/cfdiComplements/ComplementsScreen";
import AssignClarification from "./AssignClarification";
import DeleteComplement from "routes/cfdiComplements/DeleteComplement";

interface ComplementOptionsProps {
  selection: UseTableSelectionReturn;
  reloadTable: () => void;
  parentType: COMPLEMENT_PARENT;
  parentIdToDelete: string | undefined;
  clearParentIdToDelete: () => void;
}
function ComplementOptions({
  selection,
  reloadTable,
  parentType,
  parentIdToDelete,
  clearParentIdToDelete,
}: ComplementOptionsProps) {
  const [showCFDIAssing, setShowCFDIAssing] = useState(false);
  const [showCFDIClarification, setShowCFDIClarification] = useState(false);

  function parentTypeToStr(): "venta" | "traspaso" | "compra" {
    switch (parentType) {
      case COMPLEMENT_PARENT.VENTA:
        return "venta";
      case COMPLEMENT_PARENT.TRASPASO:
        return "traspaso";
      case COMPLEMENT_PARENT.RECEPCION:
      case COMPLEMENT_PARENT.COMPRA:
        return "compra";
    }
  }

  const hasSelected = useMemo(
    () => selection.anySelected,
    [selection.anySelected]
  );

  const selectionTitle = useMemo(() => {
    const capitalizedType =
      parentTypeToStr().charAt(0).toUpperCase() + parentTypeToStr().slice(1);
    if (selection.countSelected === 1) {
      return `Se ha seleccionado ${selection.countSelected} ${capitalizedType}`;
    }
    return `Se han seleccionado ${selection.countSelected} ${capitalizedType}s`;
  }, [selection.countSelected, parentType]);

  return (
    <>
      <Divider style={{ marginTop: "10px" }} />

      {hasSelected && (
        <ResponsiveCol size="lg">
          <Typography.Text style={{ color: "#1B95CA" }}>
            {selectionTitle}
          </Typography.Text>
          <Divider style={{ marginTop: "10px" }} />
        </ResponsiveCol>
      )}

      <ResponsiveCol size="lg">
        <Space>
          <Button
            type="primary"
            onClick={() => {
              setShowCFDIAssing(true);
            }}
            disabled={!hasSelected}
          >
            Asignar CFDI
          </Button>

          <Button
            type="primary"
            onClick={() => {
              setShowCFDIClarification(true);
            }}
            disabled={!hasSelected}
          >
            Asignar Aclaración
          </Button>
        </Space>
      </ResponsiveCol>

      <Divider />

      {showCFDIAssing && (
        <AssignCFDI
          onCancel={() => {
            setShowCFDIAssing(false);
          }}
          selectedKeys={selection.selectedKeys}
          onSuccess={() => {
            setShowCFDIAssing(false);
            selection.resetSelected();
            reloadTable();
          }}
          type={parentTypeToStr()}
          parentType={parentType}
        />
      )}

      {showCFDIClarification && (
        <AssignClarification
          onCancel={() => {
            setShowCFDIClarification(false);
          }}
          selectedKeys={selection.selectedKeys}
          onSuccess={() => {
            setShowCFDIClarification(false);
            selection.resetSelected();
            reloadTable();
          }}
          parentType={parentType}
        />
      )}

      {parentIdToDelete && (
        <DeleteComplement
          parentId={parentIdToDelete}
          parentType={parentType}
          onCancel={(reload) => {
            clearParentIdToDelete();
            if (reload) {
              reloadTable();
            }
          }}
        />
      )}
    </>
  );
}

export default ComplementOptions;
